import type { TranslationTag } from '@ps/web-core-intl';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';

import SuccessIcon from '@swf/core/assets/icons/success.svg';
import WarningIcon from '@swf/core/assets/icons/warning-triangle.svg';
import ErrorIcon from '@swf/core/assets/icons/warning.svg';

import {
  TXTWCL_Just_so_you_know,
  TXTWCL_Something_went_wrong,
  TXTWCL_SuccessX
} from './InfoMessage.messages.json';
import { header, icon, infoIcon, infoMessage } from './InfoMessage.scss';

interface Props {
  type: 'error' | 'confirmation' | 'warning' | 'info';
  messageTitle?: TranslationTag;
  className?: string;
}

const icons = {
  error: <ErrorIcon className={icon} />,
  confirmation: <SuccessIcon className={icon} />,
  warning: <WarningIcon className={icon} />,
  info: <InfoIcon className={infoIcon} />
};

const defaultTitle = {
  error: TXTWCL_Something_went_wrong,
  confirmation: TXTWCL_SuccessX,
  info: TXTWCL_Just_so_you_know,
  warning: TXTWCL_Just_so_you_know
};

const InfoMessage: React.FC<React.PropsWithChildren<Props>> = ({
  type,
  messageTitle,
  className,
  children
}) => (
  <StarsInfo type={type} className={classNames(infoMessage, className)}>
    <div className={header}>
      {icons[type]}
      <Translation tagName="b" {...(messageTitle || defaultTitle[type])} />
    </div>
    {children}
  </StarsInfo>
);

export default InfoMessage;
